module.exports = __webpack_public_path__ + "img/2recr_comuni.9f536a4b.png";